import { Component } from "@angular/core";

@Component({
  selector: "app-inverted-stroked-button",
  templateUrl: "./inverted-stroked-button.component.html",
  styleUrls: ["./inverted-stroked-button.component.scss"],
  standalone: false,
})
export class InvertedStrokedButtonComponent {}
